import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, ButtonContainer, Modal, ModalFooter, Spacer, TextField, Typography } from '@emburse/embark-core';
import { $t, useTranslation } from '../../../hooks/useTranslation';
import { TableAction } from '../../../interfaces/ManageUsers';
function ManageUsersModal({ onConfirm, onClose, open, header, type, confirmButtonText, switchName }) {
    useTranslation();
    const [tempPassword, setTempPassword] = useState('');
    const confirmHandler = () => {
        onClose();
        if (type === TableAction.TemporaryPassword) {
            onConfirm(tempPassword);
            setTempPassword('');
            return;
        }
        onConfirm();
    };
    const closeHandler = () => {
        setTempPassword('');
        onClose();
    };
    const modalFooter = () => (_jsx(ModalFooter, { children: _jsxs(ButtonContainer, { alignButtons: "right", children: [_jsx(Button, { variant: "outlined", onClick: closeHandler, children: $t('Cancel') }), _jsx(Button, { color: confirmButtonText === 'Delete' ? 'error' : 'primary', onClick: confirmHandler, children: confirmButtonText })] }) }));
    return (_jsx(Modal, { size: "sm", open: open, modalHeader: header, modalFooter: modalFooter(), onClose: closeHandler, children: {
            [TableAction.SendWelcomeEmails]: (_jsx(Typography, { children: $t(`This will reset passwords for all users in your search and send them a welcome email. Are you sure you want to continue?`) })),
            [TableAction.ResendWelcomeEmail]: (_jsx(Typography, { children: $t("Are you sure you want to resend this user's welcome email?") })),
            [TableAction.TemporaryPassword]: (_jsxs(_Fragment, { children: [_jsx(Typography, { children: $t(`Enter a temporary password below. The user will be prompted to change the password after logging in. Please note, the user will not be notified of the temporary password via email. The temporary password must be shared manually.`) }), _jsx(Spacer, { size: 25 }), _jsx(TextField, { id: "tempPassword", name: "Temporary Password", value: tempPassword, label: $t('Temporary Password'), type: "text", onChange: (e) => setTempPassword(e.target.value) })] })),
            [TableAction.CreateTemporaryLoginURL]: (_jsx(Typography, { children: $t('Are you sure you want to email a temporary login URL to this account?') })),
            [TableAction.MasqueradeAsUser]: (_jsx(Typography, { children: $t(`Are you sure you want to switch to user ${switchName}?`) }))
        }[type] }));
}
ManageUsersModal.defaultProps = {
    switchName: ''
};
export default ManageUsersModal;
